/**
 * @generated by @puffin-tooling/esm-build — DO NOT EDIT BY HAND.
 *
 * Source of truth: this package's CJS entry (`lib/index.js`).
 * Regenerate with `pnpm esm:build`; CI fails if this file is stale
 * (see the esmBuildFreshness cross-app contract).
 *
 * This RE-EXPORTS the CJS surface rather than duplicating it. Hand-editing
 * it reintroduces PLN-CALENDAR-RULE-001 D4: two copies of one module,
 * drifting silently.
 */

import cjs from '../schemaOrgNodes.js';

export default cjs;

export const {
  SCHEMA_CONTEXT,
  SCHEMA_DAY_OF_WEEK,
  absoluteUrl,
  buildBreadcrumbJsonLd,
  buildCollectionPageJsonLd,
  buildDatasetJsonLd,
  buildLocalBusinessJsonLd,
  buildOrganizationJsonLd,
  buildProductJsonLd,
  buildWebApplicationJsonLd,
  buildWebPageJsonLd,
  buildWebSiteJsonLd,
  geoCoordinatesNode,
  isSchemaDate,
  localBusinessId,
  localBusinessNode,
  openingHoursSpecificationNodes,
  organizationNode,
  postalAddressFromLocation,
  postalAddressNode,
  resolveAssetUrl,
  schemaTime,
  withSchemaContext,
} = cjs;
